import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeTrackDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4314_91409)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M40.5 25.0918H42.7472",
				stroke: "white",
				strokeOpacity: .24,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.78271 25.0918H7.02991",
				stroke: "white",
				strokeOpacity: .24,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 7.35669L24 5.1095",
				stroke: "white",
				strokeOpacity: .24,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 43.074L24 40.8268",
				stroke: "white",
				strokeOpacity: .24,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 23.25,
				y: 12.3811,
				width: 1.5,
				height: 13.562,
				rx: .75,
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.999 0.75C29.3156 0.750078 34.2153 2.53582 38.1318 5.53809L39.5869 4.21289C40.1554 3.69512 41.0717 3.9864 41.2373 4.7373L42.3555 9.80762C42.5211 10.5588 41.8118 11.2086 41.0781 10.9775L36.1113 9.41211C35.3758 9.18041 35.1683 8.23911 35.7383 7.71973L37.0029 6.56641C33.3751 3.85589 28.8751 2.25008 23.999 2.25C11.9864 2.25 2.25025 11.9883 2.25 24.001C2.25 36.0138 11.9861 45.75 23.999 45.75C36.0116 45.7498 45.75 36.0136 45.75 24.001C45.7499 21.4572 45.3131 19.017 44.5117 16.75C44.3737 16.3595 44.5792 15.931 44.9697 15.793C45.3601 15.6552 45.7887 15.8596 45.9268 16.25C46.7841 18.6753 47.2499 21.2846 47.25 24.001C47.25 36.8423 36.8398 47.2498 23.999 47.25C11.1577 47.25 0.75 36.8423 0.75 24.001C0.750252 11.1601 11.1577 0.75 23.999 0.75Z",
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24,
				cy: 24.6428,
				r: 1.42456,
				fill: "#8588D8"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4314_91409",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	}) })]
});
export default SvgTimeTrackDark;
